"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @Desc
 * @Author leon <leondwong@gmail.com>
 * @Date 8/3/18
 */
var request_1 = require("./request");
var common_util_1 = require("./util/common_util");
var en_GB_1 = __importDefault(require("./locale/en_GB"));
var SYS_ERROR = en_GB_1.default.SYS_ERROR;
var RestClient = /** @class */ (function () {
    function RestClient(args) {
        this.apiUrlLogin = args.apiUrlLogin;
        this.apiUrlOpen = args.apiUrlOpen;
        this.logger = new common_util_1.Logger('RestClient');
    }
    RestClient.prototype.getToken = function (code, codeVerifier, clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, opts, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.apiUrlLogin + "/oauth2.0/pkce/access-token?code=" + code + "&code_verifier=" + codeVerifier + "&client_id=" + clientId;
                        opts = {
                            headers: {
                                "Content-Type": 'application/json',
                            },
                            method: 'GET',
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, request_1.fetchRequest(url, opts)];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        data = {};
                        data.msg = err_1.stack || SYS_ERROR;
                        this.logger.error('getToken', err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (data.msg) {
                            return [2 /*return*/, data.msg];
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    RestClient.prototype.logout = function (accessToken, clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, opts, data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.apiUrlLogin + "/oauth2.0/pkce/logout";
                        opts = {
                            headers: {
                                "Content-Type": 'application/json',
                            },
                            method: 'POST',
                            body: JSON.stringify({
                                accessToken: accessToken,
                                clientId: clientId,
                            }),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, request_1.fetchRequest(url, opts)];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        data = {};
                        data.msg = err_2.stack || SYS_ERROR;
                        this.logger.error('logout', err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        // logout response data: null for success
                        if (data !== null && data.msg) {
                            return [2 /*return*/, data.msg];
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return RestClient;
}());
exports.RestClient = RestClient;
//# sourceMappingURL=rest_client.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/rest_client.js